var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"MainFooter"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.kirby.site.footer)}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.kirby.site.description)}})])}
var staticRenderFns = []

export { render, staticRenderFns }